"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityImageLink = exports.EntityImageLinkDefaultProps = exports.EntityImageIconSizes = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var router_1 = require("@reach/router");
var image_fill_1 = require("./image-fill");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_lang_1 = require("../../hooks/use-lang");
var entity_type_icon_1 = require("./entity-type-icon");
var entity_image_viewer_1 = require("./entity-image-viewer");
var entity_type_image_1 = require("./entity-type-image");
var coalesce_1 = require("../../utils/coalesce");
var react_medium_image_zoom_1 = __importDefault(require("react-medium-image-zoom"));
require("react-medium-image-zoom/dist/styles.css");
// -------- Types -------->
exports.EntityImageIconSizes = {
  small: 80,
  embed: 120,
  medium: 160,
  large: 300,
  veryLarge: 500
};
exports.EntityImageLinkDefaultProps = {
  useImageFallback: false,
  useIconFallback: false,
  useImageViewer: false,
  size: 'medium'
};
// -------- Styles -------->
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    cursor: pointer;\n    \n    ", "\n\n  "], ["\n    cursor: pointer;\n    \n    ", "\n\n  "])), function (_a) {
    var fit = _a.fit;
    return fit === 'contain' && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: ", ";\n      background: #FFF;\n    "], ["\n      padding: ", ";\n      background: #FFF;\n    "])), theme_1.theme.UNIT(4));
  })
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    cursor: pointer;\n    margin-bottom: ", ";\n  "], ["\n    cursor: pointer;\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(1))
});
var ViewerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TypeImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Image: (0, styled_components_1.default)(image_fill_1.ImageFill)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Icon: (0, styled_components_1.default)(entity_type_icon_1.EntityTypeIcon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Viewer: (0, styled_components_1.default)(entity_image_viewer_1.EntityImageViewer)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ViewerStyles),
  TypeImage: (0, styled_components_1.default)(entity_type_image_1.EntityTypeImage)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), TypeImageStyles)
};
var EntityImageLink = function (props) {
  var className = props.className,
    entity = props.entity,
    useIconFallback = props.useIconFallback,
    useImageViewer = props.useImageViewer,
    useImageFallback = props.useImageFallback,
    size = props.size;
  var openGraph = entity.openGraph,
    banner = entity.banner;
  var image = (0, coalesce_1.coalesce)(entity, ['banner.image2x', 'banner.image', 'banner.thumbnail', 'openGraph.image']);
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var t = (0, use_lang_1.useLang)();
  var onClick = function () {
    return (0, router_1.navigate)(definition.to(entity.slug));
  };
  var fit = definition.imageStyle === 'logo' ? 'contain' : 'cover';
  if (!image) {
    if (useIconFallback && definition) {
      return react_1.default.createElement(My.Icon, {
        onClick: onClick,
        entityTypeName: definition.name,
        size: 30
      });
    }
    if (useImageFallback && definition) {
      return react_1.default.createElement(My.TypeImage, {
        iconSize: exports.EntityImageIconSizes[size],
        className: className,
        entityTypeName: definition.name
      });
    }
    return null;
  }
  if (useImageViewer) {
    return react_1.default.createElement(react_medium_image_zoom_1.default, {
      wrapElement: "span"
    }, react_1.default.createElement(My.Image, {
      className: className,
      fit: fit,
      entity: image
    }));
  }
  return react_1.default.createElement(My.Image, {
    title: useImageViewer ? t('View Photo') : t('View Details'),
    className: className,
    fit: fit,
    onClick: onClick,
    entity: image
  });
};
exports.EntityImageLink = EntityImageLink;
exports.EntityImageLink.defaultProps = exports.EntityImageLinkDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;